import { z } from "zod";
import { richMenuTabGroupPostPublishSchema } from "./richmenu.schemas";

/**
 * =============================================================================
 * PUT /richmenu-tab-groups/:tabGroupId/publish API SCHEMAS
 * =============================================================================
 */

/**
 * Standard API success response base structure
 */
export const ApiSuccessResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(true),
});

/**
 * Standard API error response base structure
 */
export const ApiErrorResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(false),
	details: z.any().optional(),
});

/**
 * PUT /richmenu-tab-groups/:tabGroupId/publish - Path Parameters
 */
export const publishRichMenuTabGroupPathParamsSchema = z.object({
	tabGroupId: z.coerce.number().describe("ID of tab group to publish"),
});

/**
 * @description Successfully published rich menu tab group
 */
export const publishRichMenuTabGroup200Schema =
	ApiSuccessResponseBaseSchema.extend({
		data: richMenuTabGroupPostPublishSchema,
	}).strict();

/**
 * @description Bad request
 */
export const publishRichMenuTabGroup400Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

/**
 * @description Not found
 */
export const publishRichMenuTabGroup404Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

/**
 * @description Internal server error
 */
export const publishRichMenuTabGroup500Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

// Convenience aliases
export const publishRichMenuTabGroupMutationResponseSchema = z.lazy(
	() => publishRichMenuTabGroup200Schema,
);
